import { Injectable } from '@angular/core';
import { BookingParkingReservation } from '@products/models/booking.model';
import { TariffUuids } from '@products/models/tariff.model';

@Injectable({
  providedIn: 'root'
})
export class ParkingBookingService {
  setBookingParkingReservations(
    tariffCount: number,
    isParkingTariff: boolean,
    isLicensePlateMandatory: boolean,
    tariffUuids: TariffUuids
  ) {
    return isParkingTariff && tariffCount > 0
      ? Array.from(
          Array(tariffCount),
          (_, index): BookingParkingReservation => ({
            tariffUuid: tariffUuids[index],
            isValid: !isLicensePlateMandatory,
            licensePlateNumber: ''
          })
        )
      : [];
  }
}
